"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = require("@jsluna/grid");

var _button = require("@jsluna/button");

var _QuestionOptionBuilder = _interopRequireDefault(require("./QuestionOptionBuilder"));

var _ChoiceBuilder = _interopRequireDefault(require("./ChoiceBuilder"));

var _TextAnswerBuilder = _interopRequireDefault(require("./TextAnswerBuilder"));

var _form = require("@jsluna/form");

var _constants = require("../utils/constants");

var _lodash = require("lodash");

var _icons = require("@jsluna/icons");

var _ = require(".");

var _conditions = require("./data/conditions");

var _validation = require("./data/validation");

var _DeleteBranchesModal = _interopRequireDefault(require("./DeleteBranchesModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var renderComponentBuilder = function renderComponentBuilder(questions, id, component, handleSetQuestion, setBranchFrom, handleRemovedChoice, errors) {
  switch (component.type) {
    case _constants.CHOICE_TYPE:
      return /*#__PURE__*/_react.default.createElement(_ChoiceBuilder.default, _extends({
        questionId: id
      }, component.props, {
        setQuestion: handleSetQuestion,
        setBranchFrom: setBranchFrom,
        activeConditions: (0, _conditions.getLinkedQuestionConditions)(questions, id),
        removedChoice: handleRemovedChoice,
        errors: errors == null ? void 0 : errors.choices
      }));

    case _constants.TEXT_ANSWER_TYPE:
      return /*#__PURE__*/_react.default.createElement(_TextAnswerBuilder.default, _extends({
        id: id
      }, component.props));

    case _constants.FILE_UPLOAD_TYPE:
      return /*#__PURE__*/_react.default.createElement(_.FileUploadBuilder, _extends({
        id: id
      }, component.props));

    case _constants.RATING_TYPE:
      return /*#__PURE__*/_react.default.createElement(_.RatingBuilder, _extends({
        id: id
      }, component.props, {
        setBranchFrom: setBranchFrom,
        activeConditions: (0, _conditions.getLinkedQuestionConditions)(questions, id)
      }));

    default:
      break;
  }
};

var QuestionBuilder = function QuestionBuilder(_ref) {
  var initial = _ref.initial,
      questions = _ref.questions,
      setQuestions = _ref.setQuestions,
      setBranchFrom = _ref.setBranchFrom;

  var _useState = (0, _react.useState)(initial),
      question = _useState[0],
      setQuestion = _useState[1];

  var _useState2 = (0, _react.useState)(null),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isDeleteModalOpen = _useState3[0],
      setIsDeleteModalOpen = _useState3[1];

  (0, _react.useEffect)(function () {
    return setErrors(null);
  }, [question]);

  var hasErrors = function hasErrors(questionInput) {
    var questionErrors = (0, _validation.validateQuestions)(questionInput);

    if (!(0, _lodash.isEmpty)(questionErrors)) {
      setErrors(questionErrors);
      return true;
    }

    return false;
  };

  var handleSetQuestion = function handleSetQuestion(value, field) {
    return setQuestion((0, _lodash.set)(Object.assign({}, question), field, value));
  };

  var handleSave = function handleSave(questionInput) {
    if (hasErrors(questionInput)) return;
    setQuestions([].concat(questions.filter(function (x) {
      return x.id !== question.id;
    }), [Object.assign({}, questionInput, {
      editMode: false,
      state: _constants.questionStates.committed
    })]).sort(function (a, b) {
      return a.position - b.position;
    }));
  };

  var handleMovePosition = function handleMovePosition(position, direction) {
    var copy = [].concat(questions);
    var newPos = direction === _constants.moveDirections.up ? position - 1 : position + 1;
    var itemInPlace = copy.findIndex(function (x) {
      return x.position === newPos;
    });
    var index = copy.findIndex(function (x) {
      return x.id === question.id;
    });
    copy[index] = Object.assign({}, question, {
      position: newPos
    });
    copy[itemInPlace].position = position;
    setQuestion(Object.assign({}, question, {
      position: newPos
    }));
    setQuestions(copy.sort(function (a, b) {
      return a.position - b.position;
    }));
  };

  var handleDelete = function handleDelete() {
    var childQuestions = (0, _conditions.getChildQuestions)(questions, question.id);

    if (childQuestions.length > 0) {
      setIsDeleteModalOpen(true);
      return;
    }

    var resolvedQuestions = (0, _conditions.removeLinkedQuestionConditions)(questions, question.id);
    setQuestions([].concat(resolvedQuestions).filter(function (x) {
      return x.id !== question.id;
    }).map(function (x, i) {
      return Object.assign({}, x, {
        position: i + 1
      });
    }));
  };

  var handleClose = function handleClose(state) {
    if (state === _constants.questionStates.new) {
      handleDelete();
      return;
    }

    handleSave(initial);
  };

  var handleBranchQuestionDelete = function handleBranchQuestionDelete() {
    var filteredQuestions = questions.filter(function (q) {
      return q.id !== question.id;
    });
    var newQuestions = Array.from(filteredQuestions);
    filteredQuestions.forEach(function (item) {
      var idx = item.conditions.findIndex(function (x) {
        return x.questionId === question.id;
      });

      if (idx >= 0) {
        newQuestions.splice(idx, 1);
      }
    });
    setQuestions([].concat(newQuestions).map(function (x, i) {
      return Object.assign({}, x, {
        position: i + 1
      });
    }));
  };

  var handleSetBranchFrom = function handleSetBranchFrom(questionId, value) {
    setQuestions([].concat(questions.filter(function (x) {
      return x.id !== question.id;
    }), [Object.assign({}, question)]).sort(function (a, b) {
      return a.position - b.position;
    }));
    setBranchFrom(questionId, value);
  };

  var getNewQuestions = function getNewQuestions(questionId) {
    var newQuestions = questions.map(function (q) {
      if (q.id === questionId) {
        return Object.assign({}, question);
      }

      return q;
    });
    return newQuestions;
  };

  var handleRemovedChoice = function handleRemovedChoice(value, questionId) {
    setQuestions((0, _conditions.removedParentChoiceForcedConditionsCleanup)(getNewQuestions(questionId), value));
  };

  var handleRemovedRatings = function handleRemovedRatings(questionId, values) {
    setQuestions((0, _conditions.removedParentRatingsForcedConditionsCleanup)(getNewQuestions(questionId), questionId, values));
  };

  return /*#__PURE__*/_react.default.createElement("div", null, isDeleteModalOpen && /*#__PURE__*/_react.default.createElement(_DeleteBranchesModal.default, {
    isOpen: isDeleteModalOpen,
    setQuestions: setQuestions,
    setIsOpen: setIsDeleteModalOpen,
    questions: questions,
    handleBranchQuestionDelete: handleBranchQuestionDelete
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "4/5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, question.state === _constants.questionStates.new ? 'Add something new' : 'Editing')), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/5",
    className: "ln-u-text-align-right ln-u-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    label: "Close option menu",
    color: "dark",
    hideLabel: true,
    onClick: function onClick() {
      return handleClose(question.state);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Cancel, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '2/12',
      ss: '1/12'
    }
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "ln-u-padding-top"
  }, question.position, ".")), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '10/12',
      ss: '11/12'
    },
    className: "ln-u-hard-left"
  }, /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    required: true,
    maxLength: 100,
    placeholder: "Question " + question.position,
    value: question.title,
    onChange: function onChange(e) {
      return handleSetQuestion(e.target.value, 'title');
    },
    name: question.id + "-title",
    error: errors && errors.title
  })), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1",
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ln-u-color-grey-50"
  }, question.description), renderComponentBuilder(questions, question.id, question.component, handleSetQuestion, handleSetBranchFrom, handleRemovedChoice, errors)), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1",
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement("hr", null)), /*#__PURE__*/_react.default.createElement(_QuestionOptionBuilder.default, {
    question: question,
    setQuestion: handleSetQuestion,
    removedRatings: handleRemovedRatings
  }), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1",
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    fullWidth: true,
    onClick: function onClick() {
      return handleSave(question);
    }
  }, question.state === _constants.questionStates.new ? 'Add question' : 'Save question')), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/2'
    },
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    disabled: question.position === 1 || questions.length === 0,
    onClick: function onClick() {
      return handleMovePosition(question.position, _constants.moveDirections.up);
    },
    className: "ln-u-bg-color-white"
  }, "Move up")))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/2'
    },
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    disabled: question.position === questions.length || questions.length === 0,
    onClick: function onClick() {
      return handleMovePosition(question.position, _constants.moveDirections.down);
    },
    className: "ln-u-bg-color-white"
  }, "Move down")))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/2'
    },
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: function onClick() {
      return handleDelete();
    },
    className: "ln-u-bg-color-white"
  }, "Delete question"))))));
};

QuestionBuilder.propTypes = {
  /** The initial values of the question component to be built */
  initial: _propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    }),

    /** Indicates whether the question is currently being edited */
    editMode: _propTypes.default.bool
  }).isRequired,

  /** An array of any existing questions */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    }),

    /** Indicates whether the question is currently being edited */
    editMode: _propTypes.default.bool
  })).isRequired,

  /** Function to amend the current list of questions */
  setQuestions: _propTypes.default.func.isRequired,

  /** Function to set the question/value combination for branching questions */
  setBranchFrom: _propTypes.default.func.isRequired
};
var _default = QuestionBuilder;
exports.default = _default;